export const MensajesSuscripcionesDeshabilitadas = [
    "",
    "Esta suscripción no tiene forma de pago habilitada por ser un beneficio",
    "Esta suscripción se administra a través de Google",
    "Esta suscripción se administra a través de Apple",
]